// import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Component, Inject, OnDestroy } from '@angular/core';
import { Store } from '@src/store';
import { userActions } from "../../../store/reducers/userReducer";
import { projectsActions } from "../../../store/reducers/projectsReducer";
// import { logsActions } from '@src/store/reducers/logsReducer';
import moment from 'moment';
import { logsActions } from '@src/store/reducers/logsReducer';

@Component({
    selector: 'log-viewer',
    template: require('./log-viewer.component.html'),
    styles: [require('./log-viewer.component.scss')]
})
export class LogComponent implements OnDestroy {
    public filterlogs: any
    public unsubscribe: any
    public pageId: number
    public resetSize:boolean =false;
    public logDate: any = []
    public flagpaging:boolean = true;
    public quantity = 15
    public loadOnce: boolean = true;
    constructor(private store: Store, @Inject('logsLocalHistoryService') private logsLocalHistoryService: any) {
        this.unsubscribe = this.store.subscribe(() => { });

        store.dispatch({ type: projectsActions.GET_PROJECTS });
        store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            this.createCookie("uuid_client", res.data.id);
            store.dispatch({ type: userActions.GET_USER, payload: { userId: res.data.id } });
        });
    }

    public flagpag(flag:boolean){
        this.flagpaging = flag;
      }

    public filter(filter) {
        this.logDate = []
        const uuid = this.readCookie("uuid_client");
        this.logsLocalHistoryService.UpdateLogHitory(uuid, filter.data);
        let logsData = this.store.getState().logs.logs;
        if (logsData && logsData.length > 0) {
            if (filter.data.firstTime) {
                filter.data.defaultEndTime = logsData[0].LoggedTime;
                filter.data.firstTime = false;
            }
        }
        filter.data.firstTime = true;
        this.filterlogs = filter.data;
        this.getLogs()
    }

    getDataFromServer() {
        this.store.dispatch({ type: projectsActions.GET_PROJECTS });
    }

    
    getLogs(page = 1) {
        this.resetSize = false
        this.pageId = page;
        let cr: any = {}
        this.loadOnce = true;
        let projectId = this.filterlogs.project == null ? null : this.filterlogs.project.id;
        let envId = this.filterlogs.env == null ? null : (this.filterlogs.env.isAll) ? -1 : this.filterlogs.env.id;
        let schemaId = this.filterlogs.schema == null ? null : (this.filterlogs.schema.isAll) ? -1 : this.filterlogs.schema.id;
        if(this.filterlogs.fromFilter){
            this.pageId = 1;
            this.resetSize = true
        }
        var payload = {
            "StartTime": (this.filterlogs.fromDate) ? this.convertDate(this.filterlogs.fromDate, this.filterlogs.fromTime, "start") : null,
            "EndTime": (this.filterlogs.defaultEndTime && this.filterlogs.firstTime == false) ? this.filterlogs.defaultEndTime : (this.filterlogs.toDate) ? this.convertDate(this.filterlogs.toDate, this.filterlogs.toTime, "end") : null,
            "LogLevlsIds": null,
            "IsGlobal": this.filterlogs.isGlobal,
            "CriteriaFields": cr,
            "PageNumber": this.pageId,
            "PageCount": this.quantity,
            "OrderBy": "DATETIME",
            "IsDesc": "True",

        };

        if (projectId != null && projectId != -1)
            payload.CriteriaFields.ProjectId = projectId.toString();
        if (envId != null && envId != -1)
            payload.CriteriaFields.EnvironmentId = envId.toString();
        if (schemaId != null && schemaId != -1)
            payload.CriteriaFields.SchemaId = schemaId.toString();
        if (this.filterlogs.logLevels != null)
            payload.LogLevlsIds = this.filterlogs.logLevels;

        this.store.dispatch({ type: logsActions.GET_LOGS, payload: { data: payload } }).then(res => {
            if (res && res.length > 0)  {
            if(this.filterlogs.fromFilter){
                this.logDate = [];
                this.logDate = [...this.logDate, ...res]
                this.filterlogs.fromFilter = false;
            }
                if(this.flagpaging){
                    this.logDate = [...this.logDate, ...res]
                    this.flagpaging = false
                }
                else { 
                    this.pageId = 1;
                }
     
            }
        });
    }

    convertDate(date, time, flag) {
        var tt = moment(time, "HH:mm");
        if (flag == "start" && !time) {
            tt = moment().startOf('day');
        } else if (flag == "end" && !time) {
            tt = moment().endOf('day');
        }

        const toDateTime = moment(date).local().set({
            'hour': tt.get('hour'),
            'minute': tt.get('minute'),
            'second': tt.get('second')
        });
        return toDateTime.toDate();
    }

    createCookie = (name, value) => {
        var expires = "";
        
        var cookieString = name + "=" + value + expires + "; path=/ ;";

        //add secure cookie property if needed (based on the env.js config- default is 'false')
        if(window.__env.config.secureCookie === true)
            cookieString += "secure = true;";
        document.cookie = cookieString;
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

    readCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }



}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/log-viewer-ang7/log-viewer.component.ts